import { apiConfig } from 'core-lib/config/config';
import { API_STATUS } from 'core-lib/constants/network';
import { getMethod } from 'core-lib/utils/api';
import { createAction } from 'redux-actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { inventorySerializer } from '../utils/serializer';
import {
  GET_EXPLORE_MARKETPLACE,
  GET_FEEDBACK_DATA,
  GET_HISTORY,
  GET_RECENT_LISTING,
  GET_RECOMMENDED,
  GET_TRENDING,
  GET_WISHLIST,
  GET_WISHLIST_START,
  UPDATE_BRAND_LIST,
  UPDATE_CITY_LIST,
  UPDATE_COORDINATES,
  // UPDATE_LOCATION,
  UPDATE_MAPPED_LOCATION,
  UPDATE_NEARYBY_CITIES,
  UPDATE_SIMILAR_BY_PRICE,
} from './type';

export const getHistory = createAction(GET_HISTORY);
export const getTrending = createAction(GET_TRENDING);
export const getWishListStart = createAction(GET_WISHLIST_START);
export const getWishList = createAction(GET_WISHLIST);
export const getRecommended = createAction(GET_RECOMMENDED);
// export const updateLocation = createAction(UPDATE_LOCATION);
export const updateCityList = createAction(UPDATE_CITY_LIST);
export const getRecentListing = createAction(GET_RECENT_LISTING);
export const updateSimilarByPrice = createAction(UPDATE_SIMILAR_BY_PRICE);
export const getExploreMarketPlace = createAction(GET_EXPLORE_MARKETPLACE);
export const getFeedBackData = createAction(GET_FEEDBACK_DATA);
export const updateBrandList = createAction(UPDATE_BRAND_LIST);
export const updateMappedLocation = createAction(UPDATE_MAPPED_LOCATION);
export const updateCoordinates = createAction(UPDATE_COORDINATES);
export const updateNearbyCities = createAction(UPDATE_NEARYBY_CITIES);

function serializer(data) {
  return {
    count: data?.data?.list_count,
    data: data?.data?.list_data?.map((item) => inventorySerializer(item)),
  };
}

function* getWishListData() {
  console.log('in wishlist start');
  let wishList = {
    apiStatus: API_STATUS.in_progress,
    list: [],
    count: 0,
    currentPage: 0,
    hasMore: true,
  };

  yield put(getWishList(wishList));

  const url = `${apiConfig(
    'dealer'
  )}/v1/ucd/dealer/d2c/get-favourites-list/?limit=${100}&page=${1}`;

  const { response, error }: any = yield call(getMethod, url);

  if (response) {
    const formattedData = serializer(response);
    wishList = {
      apiStatus: API_STATUS.success,
      list: formattedData?.data,
      count: formattedData?.count,
      currentPage: 1,
      hasMore: formattedData?.count > 10,
    };
  } else {
    wishList = {
      apiStatus: API_STATUS.failure,
      list: [],
      count: 0,
      currentPage: 0,
      hasMore: false,
    };
  }
  yield put(getWishList(wishList));
}

export function* watchWishlist() {
  yield takeEvery(GET_WISHLIST_START, getWishListData);
}
